<template>
  <v-btn :disabled="disabled" :text="!useIcon" :icon="useIcon" :color="!useIcon ? 'tertiary' : '#343434'" class="pa-0" :style="!useIcon ? 'height: auto; width: auto' : undefined" @click="$emit('click')">
    <v-tooltip v-if="useIcon && tooltip" bottom>
      <template #activator="{ on }">
        <v-icon v-on="on">
          {{ icon }}
        </v-icon>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <template v-else-if="!tooltip && icon">
      <v-icon>{{ icon }}</v-icon>
    </template>
    <template v-else>
      {{ text }}
      <template v-if="notMobile">
        <v-icon>keyboard_arrow_right</v-icon>
      </template>
    </template>
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    icon: { type: String, default: null },
    text: { type: String, required: true },
    tooltip: { type: String, default: null },
    showArrow: { type: Boolean, default: false }
  },
  computed: {
    notMobile() {
      return this.$vuetify.breakpoint.smAndUp
    },
    useIcon() {
      return this.notMobile && !!this.icon
    }
  }
}
</script>
